<div class="flex-container" [class]="controlAction">
  <ng-container *ngFor="let broadcastGamePair of relatedBroadcasts">
    <app-status [broadcast]="broadcastGamePair.broadcast" [game]="broadcastGamePair.game" [simple]="true"></app-status>
  </ng-container>
</div>
